import { BookOpen, Briefcase, Users, Mail } from 'lucide-react';
import { StatCard } from './StatCard';
import { EnquiriesTable } from './EnquiriesTable';

const visitorData = [
  { month: 'Jan', visitors: 4200 },
  { month: 'Feb', visitors: 5100 },
  { month: 'Mar', visitors: 4800 },
  { month: 'Apr', visitors: 6200 },
  { month: 'May', visitors: 7500 },
  { month: 'Jun', visitors: 8200 },
];

const contentData = [
  { month: 'Jan', blogs: 12, portfolios: 8 },
  { month: 'Feb', blogs: 15, portfolios: 10 },
  { month: 'Mar', blogs: 18, portfolios: 12 },
  { month: 'Apr', blogs: 14, portfolios: 9 },
  { month: 'May', blogs: 20, portfolios: 15 },
  { month: 'Jun', blogs: 22, portfolios: 14 },
];

const enquiryDistribution = [
  { name: 'New', value: 45, color: '#2563eb' },
  { name: 'Replied', value: 35, color: '#3b82f6' },
  { name: 'Closed', value: 20, color: '#60a5fa' },
];

const Dashboard = () => {
  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard title="Total Blogs" value="124" icon={BookOpen} gradient />
        <StatCard title="Total Portfolios" value="68" icon={Briefcase} gradient />
        <StatCard title="Website Visitors" value="8.2K" icon={Users} gradient />
        <StatCard title="Total Enquiries" value="342" icon={Mail} gradient />
      </div>
      <EnquiriesTable />
    </div>
  );
}
export default Dashboard;